import { render, staticRenderFns } from "./UserJoin.vue?vue&type=template&id=ccbe4118"
import script from "./UserJoin.vue?vue&type=script&lang=js"
export * from "./UserJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports